










































import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import { Placeholder, PlaceholdersStack as PlaceholdersStackType } from '../Toolbar/types'
import PlaceholderSections from './components/PlaceholderSections.vue'
import PlaceholderValueItem from './components/PlaceholderValueItem.vue'
import PlaceholderMixin from './mixins/PlaceholderMixin'

@Component({
  components: {
    PlaceholderSections,
    PlaceholderValueItem
  }
})
export default class PlaceholdersStack extends Mixins<PlaceholderMixin>(PlaceholderMixin) {
  @Prop() placeholders!: PlaceholdersStackType

  @Emit('insert')
  insertPlaceholder(val: Placeholder['value']): Placeholder['value'] {
    return val
  }
}
